import { Stack } from "expo-router";

/**
 * The public browse storefront's layout. It stays mounted across the list (`[eventId]`) and item
 * detail (`[eventId]/[itemId]`), and the nested `<Stack>` mirrors the root's `headerShown: false`
 * so list-to-detail keeps push and back navigation.
 *
 * It sets no skin: the surface comes from the base tokens in `global.css`.
 */
export default function BrowseLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
